let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dqqJK")).then(() => parcelRequire('i6cnj'));